const fruits = {
    productData: [
        {
            id: 1,
            img: require('../Components/Images/Fruits/Acai-Berry-Fruit-150x150.webp'),
            title: 'Acai-Berry',
            desc: '',
            price: '87.00',
        },
        {
            id: 2,
            img: require('../Components/Images/Fruits/Almond-Fruit-150x150.webp'),
            title: 'Almond ',
            desc: '',
            price: '87.00',
        },
        {
            id: 3,
            img: require('../Components/Images/Fruits/Apple-Fruit-150x150.webp'),
            title: 'Apple',
            desc: '',
            price: '87.00',
        },
        {
            id: 4,
            img: require('../Components/Images/Fruits/Apricot-Fruit-150x150.webp'),
            title: 'Apricot',
            desc: '',
            price: '87.00',
        },
        {
            id: 5,
            img: require('../Components/Images/Fruits/Avocado-Fruit-150x150.webp'),
            title: 'Ashgourd',
            desc: '',
            price: '87.00',
        },
        {
            id: 6,
            img: require('../Components/Images/Fruits/Banana-Fruit-150x150.webp'),
            title: 'Banana',
            desc: '',
            price: '87.00',
        },
        {
            id: 7,
            img: require('../Components/Images/Fruits/Barberry-Fruit-150x150.webp'),
            title: 'Barberry',
            desc: '',
            price: '87.00',
        },
        {
            id: 8,
            img: require('../Components/Images/Fruits/Blackberry-Fruit-150x150.webp'),
            title: 'Blackberry',
            desc: '',
            price: '87.00',
        },
        {
            id: 9,
            img: require('../Components/Images/Fruits/Blueberry-Fruit-150x150.webp'),
            title: 'Blueberry',
            desc: '',
            price: '87.00',
        },
        {
            id: 10,
            img: require('../Components/Images/Fruits/Breadfruit-Fruit-150x150.webp'),
            title: 'Breadfruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 11,
            img: require('../Components/Images/Fruits/Cashew-Apple-Fruit-150x150.webp'),
            title: 'Cashew',
            desc: '',
            price: '87.00',
        },
        {
            id: 12,
            img: require('../Components/Images/Fruits/Cashew-Fruit-150x150.webp'),
            title: 'Cashew Nuts',
            desc: '',
            price: '87.00',
        },
        {
            id: 13,
            img: require('../Components/Images/Fruits/Cherry-Fruit-150x150.webp'),
            title: 'Cherry',
            desc: '',
            price: '87.00',
        },
        {
            id: 14,
            img: require('../Components/Images/Fruits/Custard-Apple-Fruit-150x150.webp'),
            title: 'Custard',
            desc: '',
            price: '87.00',
        },
        {
            id: 15,
            img: require('../Components/Images/Fruits/Date-Fruit-150x150.webp'),
            title: 'Dates',
            desc: '',
            price: '87.00',
        },
        {
            id: 16,
            img: require('../Components/Images/Fruits/Dragon-Fruit-150x150.webp'),
            title: 'Dragon Fruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 17,
            img: require('../Components/Images/Fruits/Fig-Fruit-150x150.webp'),
            title: 'Fig Fruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 18,
            img: require('../Components/Images/Fruits/Gooseberry-Fruit-150x150.webp'),
            title: 'Gooseberry',
            desc: '',
            price: '87.00',
        },
        {
            id: 19,
            img: require('../Components/Images/Fruits/Grapefruit-150x150.webp'),
            title: 'Grapefruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 20,
            img: require('../Components/Images/Fruits/Grapes-Fruit-150x150.webp'),
            title: 'Grapes',
            desc: '',
            price: '87.00',
        },
        {
            id: 21,
            img: require('../Components/Images/Fruits/Guava-Fruit-150x150.webp'),
            title: 'Guava',
            desc: '',
            price: '87.00',
        },
        {
            id: 22,
            img: require('../Components/Images/Fruits/Jackfruit-Fruit-150x150.webp'),
            title: 'Jackfruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 23,
            img: require('../Components/Images/Fruits/Jujube-Fruit-150x150.webp'),
            title: 'Jujube',
            desc: '',
            price: '87.00',
        },
        {
            id: 24,
            img: require('../Components/Images/Fruits/Kiwifruit-Fruit-150x150.webp'),
            title: 'Kiwifruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 25,
            img: require('../Components/Images/Fruits/Kumquat-Fruit-150x150.webp'),
            title: 'Kumquat',
            desc: '',
            price: '87.00',
        },
        {
            id: 26,
            img: require('../Components/Images/Fruits/Lemon-Fruit-150x150.webp'),
            title: 'Lemon',
            desc: '',
            price: '87.00',
        },
        {
            id: 27,
            img: require('../Components/Images/Fruits/Lychee-Fruit-150x150.webp'),
            title: 'Lychee',
            desc: '',
            price: '87.00',
        },
        {
            id: 28,
            img: require('../Components/Images/Fruits/Malay-Apple-Fruit-150x150.webp'),
            title: 'Malay Apple',
            desc: '',
            price: '87.00',
        },
        {
            id: 29,
            img: require('../Components/Images/Fruits/Mango-Fruit-150x150.webp'),
            title: 'Mango',
            desc: '',
            price: '87.00',
        },
        {
            id: 30,
            img: require('../Components/Images/Fruits/Muskmelon-Fruit-150x150.webp'),
            title: 'Muskmelon',
            desc: '',
            price: '87.00',
        },
        {
            id: 31,
            img: require('../Components/Images/Fruits/Olive-Fruit-150x150.webp'),
            title: 'Olive Fruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 32,
            img: require('../Components/Images/Fruits/Orange-Fruit-150x150.webp'),
            title: 'Orange',
            desc: '',
            price: '87.00',
        },
        {
            id: 33,
            img: require('../Components/Images/Fruits/Palm-Fruit-150x150.webp'),
            title: 'Palm',
            desc: '',
            price: '87.00',
        },
        {
            id: 34,
            img: require('../Components/Images/Fruits/Papaya-Fruit-150x150.webp'),
            title: 'Papaya',
            desc: '',
            price: '87.00',
        },
        {
            id: 35,
            img: require('../Components/Images/Fruits/Passion-Fruit-150x150.webp'),
            title: 'Passion Fruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 36,
            img: require('../Components/Images/Fruits/Peach-Fruit-150x150.webp'),
            title: 'Peach',
            desc: '',
            price: '87.00',
        },
        {
            id: 37,
            img: require('../Components/Images/Fruits/Pear-Fruit-150x150.webp'),
            title: 'Pear',
            desc: '',
            price: '87.00',
        },
        {
            id: 38,
            img: require('../Components/Images/Fruits/Persimmon-Fruit-150x150.webp'),
            title: 'Persimmon',
            desc: '',
            price: '87.00',
        },
        {
            id: 39,
            img: require('../Components/Images/Fruits/Pineapple-Fruit-150x150.webp'),
            title: 'Pineapple Fruit',
            desc: '',
            price: '87.00',
        },
        {
            id: 40,
            img: require('../Components/Images/Fruits/Pomegranate-Fruit-150x150.webp'),
            title: 'Pomegranate',
            desc: '',
            price: '87.00',
        },
        {
            id: 41,
            img: require('../Components/Images/Fruits/Prickly-Pear-Fruit-150x150.webp'),
            title: 'Prickly Pear',
            desc: '',
            price: '87.00',
        },
        {
            id: 42,
            img: require('../Components/Images/Fruits/Quince-Fruit-150x150.webp'),
            title: 'Quince',
            desc: '',
            price: '87.00',
        },
        {
            id: 43,
            img: require('../Components/Images/Fruits/Red-Banana-Fruit-150x150.webp'),
            title: 'Red Banana',
            desc: '',
            price: '87.00',
        },
        {
            id: 44,
            img: require('../Components/Images/Fruits/Strawberry-Fruit-150x150.webp'),
            title: 'Strawberry',
            desc: '',
            price: '87.00',
        },
        {
            id: 45,
            img: require('../Components/Images/Fruits/Sugar-Cane-Fruit-150x150.webp'),
            title: 'SugarCane',
            desc: '',
            price: '87.00',
        },
        {
            id: 46,
            img: require('../Components/Images/Fruits/Tamarind-Fruit-150x150.webp'),
            title: 'Tamarind',
            desc: '',
            price: '87.00',
        },
        {
            id: 47,
            img: require('../Components/Images/Fruits/Water-Chestnut-Fruit-150x150.webp'),
            title: 'Water Chestnut',
            desc: '',
            price: '87.00',
        },
        {
            id: 48,
            img: require('../Components/Images/Fruits/Wood-Apple-Fruit-150x150.webp'),
            title: 'Wood Apple',
            desc: '',
            price: '87.00',
        },
    ]
}

export default fruits; 